import axios from "axios";
import apiUrl from "./apiConfig";

export const sendAssignments = (data) => {
    return axios.post(`${apiUrl}/dashboard/assign-patient-exercise`, data);
};

export const getPatientExercises = async (patientId = null) => {
    try {
        const params = patientId ? { patientId } : {};
        const response = await axios.get(`${apiUrl}/dashboard/get-patient-exercise-list`, {
            params,
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error fetching patient exercises:", error);
        throw error;
    }
};

export const getSystemStats = async () => {
    try {
        const response = await axios.get(`${apiUrl}/admin/stats`, {
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error fetching system stats:", error);
        throw error;
    }
};

export const scheduleAppointmentEmail = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/schedule-appointment-email`, data, {
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error sending appointment email:", error);
        throw error;
    }
};

export const recordPatientExercise = async (data) => {
    try {
        console.log("Recording Patient Exercise - Request Data:", JSON.stringify(data, null, 2));
        const response = await axios.post(`${apiUrl}/dashboard/record-patient-exercise`, data, {
            withCredentials: true,
        });
        console.log("Recording Patient Exercise - Response:", response.data);
        return response;
    } catch (error) {
        console.error("Error recording patient exercise:", error);
        throw error;
    }
};

export const removePatientExercises = async (data) => {
    try {
        const response = await axios.delete(`${apiUrl}/dashboard/remove-patient-exercise`, {
            data: data,
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error removing patient exercises:", error);
        throw error;
    }
};

export const getPatientSoapNotes = async (patientId) => {
    try {
        const response = await axios.get(`${apiUrl}/dashboard/getPatientSoapNotes`, {
            params: { patientId },
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error fetching patient soap notes:", error);
        throw error;
    }
};

export const getSoapNote = async (patientId, noteId) => {
    try {
        const response = await axios.get(`${apiUrl}/dashboard/getSoapNote`, {
            params: { patientId, noteId },
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error fetching soap note:", error);
        throw error;
    }
};

export const postSoapNote = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/dashboard/postSoapNote`, data, {
            withCredentials: true,
        });
        return response;
    } catch (error) {
        console.error("Error posting soap note:", error);
        throw error;
    }
};